var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7583 16.2288H12.8862V14.8592H16.7583V10.9871H18.128V14.8592H22V16.2288H18.128V20.1009H16.7583V16.2288ZM18.4437 5.51743V7.42188H17.074V1.36967H2.53799C1.89356 1.36967 1.36967 1.89425 1.36967 2.53868V15.4745L2.20516 15.0287C2.58936 14.8239 3.04819 14.8239 3.4317 15.0294L4.98422 15.8559L6.4751 15.0287C6.85861 14.8246 7.31745 14.8246 7.70027 15.0287L9.2521 15.8559L9.83489 17.064C9.4507 17.2694 8.99186 17.2694 8.60836 17.0647L7.05584 16.2374L5.56564 17.0647C5.3732 17.1667 5.16364 17.2181 4.95272 17.2181C4.74179 17.2181 4.53154 17.1667 4.33911 17.064L2.78727 16.2374L1.91479 16.7353C1.50732 16.9531 1.02725 16.9407 0.632102 16.7031C0.236268 16.4655 0 16.0477 0 15.5861V2.53868C0 1.13888 1.13819 0 2.53799 0H17.7584C18.5727 0 19.285 0.298314 19.8165 0.861932C21.104 2.22749 20.9697 4.76548 20.9636 4.873L20.9259 5.51743H18.4437ZM18.4437 4.14776V1.51857C18.5815 1.58764 18.7058 1.68109 18.818 1.79947C19.3556 2.36856 19.5405 3.40883 19.5884 4.14776H18.4437ZM4.15667 5.74199H14.286V4.37232H4.15667V5.74199ZM4.15667 8.79155H14.286V7.42188H4.15667V8.79155ZM4.15667 11.8404H11.3022V10.4708H4.15667V11.8404Z",
    fill: "#FF5956"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateOrder);
export default __webpack_public_path__ + "static/media/createOrder.f7fc83a7ecbcffdc9438c794f8f6df67.svg";
export { ForwardRef as ReactComponent };